export default __webpack_public_path__ + "static/media/action.6bc4f942.png";